import React, { Component } from 'react'
// import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { db } from "../firebase";
import { ChevronRight} from "@material-ui/icons";
import firebaseApp from '../firebase';
export default class Footer extends Component {
    state = {
        links : [],
        link : ''
    }
      _handleKeyDown = (e) => {
          let v = this.state.links
          v.push(this.state.link)

          db.collection("Footer").doc("k4rUL6NpkJe1DFKUenci").set({
            link : v
        })
        .then(function() {
            console.log("Document successfully written!");
        })
        .catch(function(error) {
            console.error("Error writing document: ", error);
        });
      }
      handleChange= (e)=>{
        const {value, name} = e.target;
        console.log(name);
        this.setState({...this.state, [name]:value})
      }
    
      componentDidMount(){
        const that= this;
       
        firebaseApp.auth().onAuthStateChanged(function(user) {
          if (user) {
           that.setState({
             ...that.state, admin:user
           })
          } else {
            that.setState({
              ...that.state, admin:""
            })
          }
          });
    
          db.collection("Footer").get().then(snapshot =>{
            const homeDetails=[];
            snapshot.forEach(doc=>{
                const data = doc.data();
                console.log(data);
                homeDetails.push(data)
            });
            that.setState({...that.state,
              links: homeDetails[0].link
              })
        })
      }
    render() {
        
        return (
            <div className="flexa">
                <div style={{width:"40%",padding:'5px',margin:'5px'}}>
                    <h3>Disclaimer</h3>
                    <p style={{fontSize:"10px"}}>The information provided at this website general informational purposes only. All information on the Site is provided in good faith, however we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability or completeness of any information on the Site. UNDER NO CIRCUMSTANCE SHALL WE HAVE ANY LIABILITY TO YOU FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF THE SITE OR RELIANCE ON ANY INFORMATION PROVIDED ON THE SITE. YOUR USE OF THE SITE AND YOUR RELIANCE ON ANY INFORMATION ON THE SITE IS SOLELY AT YOUR OWN RISK. THE INFORMATION PROVIDED IS NOT NECESSARILY THE IDEAS/EXPRESSIONS OF THE OWNER. THE INFORMATION SHARED ON THIS DOES NOT REPRESENT THE IDEAS/EXPRESSIONS/THOUGHTS OF THE WEBSITE DEVELOPER AND HE/SHE SHALL NOT BE LIABLE FOR ANY CONTENT SHARED ON THE WEBSITE.</p>
                </div>
                <div style={{width:"50%",padding:'5px',margin:'5px'}}>
                {this.state.admin? <><input style={{background: "white", }} name="link" type="text" onChange={this.handleChange} value={this.state.link}/><button onClick={this._handleKeyDown}>Add Link</button></>
                  : <div></div>
          }
                    <h3>Related Links</h3>
                    {
                    this.state.links.map((link,idx)=>(
                    <a target="_blank" rel="noreferrer" href={`${link}`} style={{color:"white",textDecoration:"none",textTransform:"lowercase"}}><ChevronRight/>   {link}<br/></a>
                    ))
                    }
                </div>
            </div>
        )
    }
}
